module.exports = __webpack_public_path__ + "static/media/critical_illness_fisdom.42f1d765.svg";